import main from './main/main';
import home from './main/home';
import message from './main/message';
import my_info from './main/my-info';
import locking from './main/locking';
import login from './login';
import organization from './organization';
import content from './content';
import sys_manage from './sys_manage';
import sys_monitor from './sys_monitor';

export default {
    main,
    home,
    message,
    my_info,
    locking,
    ...login,
    ...sys_manage,
    ...sys_monitor,
    ...content,
    ...organization,
};
